import { Component, OnInit } from '@angular/core';
import { RootScopeService } from '../../../services/root-scope.service';
import * as Constants from './../../../models/Constants';
import { GenesysCloudService } from '../../../services/genesys-cloud.service';
import { AuthMethodService } from '../../../services/auth-method.service';
import { LogService } from 'src/app/services/log.service';

@Component({
  selector: 'app-voluntary-account-lock',
  templateUrl: './voluntary-account-lock.component.html',
  styleUrls: ['./voluntary-account-lock.component.scss']
})
export class VoluntaryAccountLockComponent implements OnInit {

  /** Story No CCR1-8079 ***/

  // displayContentBeforeStep1: boolean = true;
  displayStep2Content: boolean = false;
  displayStep1Content: boolean = false;
  valLangList: { label: string; code: any; }[] = [{ 'label': "English", 'code': 'en-US' }];
  selectedLanguage: string = "NA";
  enableStepper: boolean = false;
  fileName: string = "voluntary-account-lock_component";

  constructor(public rootScope: RootScopeService,
    public genesysCloudService: GenesysCloudService,
    public authService: AuthMethodService, public logger: LogService) {
    this.getVALLanguageList()

  }

  ngOnInit(): void {

  }

  disableAcountLockButton() {
    if (this.selectedLanguage != 'NA' && this.selectedLanguage != null && this.selectedLanguage != '')
      return false;
    else
      return true;
  }

  getVALLanguageList(): void {
    let clientConfigArr = this.rootScope.clientPropDataMap.get(this.rootScope.activeCustTab.clientId);
    if (clientConfigArr && clientConfigArr.length > 0) {
      const multiLangObj = clientConfigArr.find(item => item?.propertyName === Constants.VAL_LANGUAGE_PROPERTYNAME);
      /* istanbul ignore next */
      if (multiLangObj) {
        const parsedLanguages = JSON.parse(multiLangObj?.propertyValue);
        this.valLangList = Object.keys(parsedLanguages).map(key => ({
          label: key,
          code: parsedLanguages[key]
        })).sort((a, b) => a.label.localeCompare(b.label));
        if (this.valLangList?.length == 0) {
          this.setDefaultLanguageList();
        }
      }
      else{
        this.setDefaultLanguageList()
      }
    }
    else {
      this.setDefaultLanguageList();
    }
  }

  setDefaultLanguageList() {
    this.valLangList = [{ 'label': "English", 'code': 'en-US' }]
    this.rootScope.activeCustTab.selectedVALLang = this.valLangList[0].code;
    this.selectedLanguage = this.rootScope.activeCustTab.selectedVALLang;
    /* istanbul ignore next */
    this.logger.infoLogs("Default slected Language: " + this.rootScope.activeCustTab.selectedVALLang, this.fileName);

  }

  initiateAccountLock() {
    this.rootScope.activeCustTab.VALData.displayContentBeforeStep1 = false;
    this.rootScope.activeCustTab.VALData.displayStep1Content = true;
    this.rootScope.activeCustTab.VALData.enableStepper = true;
    this.rootScope.activeCustTab.VALData.step1Complete = false
    this.rootScope.activeCustTab.VALData.step1Active = true;
    this.rootScope.activeCustTab.VALData.step2Complete = false;
    this.rootScope.activeCustTab.VALData.step3Complete = false;
    /*istanbul ignore next */
    this.logger.infoLogs("Step 1 Content Displayed: " + JSON.stringify(this.rootScope.activeCustTab.VALData), this.fileName);
  }

  moveToStep2() {
    this.rootScope.activeCustTab.selectedVALLang = this.selectedLanguage;
    this.rootScope.activeCustTab.VALData.displayStep2Content = true;
    this.rootScope.activeCustTab.VALData.displayStep1Content = false;
    this.rootScope.activeCustTab.VALData.step2Active = true;
    this.rootScope.activeCustTab.VALData.step1Active = false;
    this.rootScope.activeCustTab.VALData.step2Complete = false;
    this.rootScope.activeCustTab.VALData.step3Complete = false;
     /* istanbul ignore next */
    this.logger.infoLogs("Step 2 Content Actived", this.fileName);
    this.sendVALAttributesToGenesys();
  }

  sendVALAttributesToGenesys() {
    let body: any = {
      attributes: {
        PII: this.rootScope.getPIIbySystemInstaneId(this.rootScope.accountSAuthConfig?.authsystemInstanceId),
        CS_LANGUAGE_CODE: this.rootScope.activeCustTab.selectedVALLang ? this.rootScope.activeCustTab.selectedVALLang : "en-US",
        PINV: Constants.PINV_ATTRIBUTES.FULLY_SECURED,
        CS_XFER_USER_ID: this.rootScope.userData?.racfId,
        CS_PIN_CLNT_ID: this.authService.clientSystemMappingForSauthAndReplace(this.rootScope.activeCustTab?.clientId),
        CS_PIN_SYSTEM_INSTANCE_ID: this.rootScope.accountSAuthConfig?.authsystemInstanceId
      },
    };

    /*  CCR1-10428 */
    if (!this.rootScope.Prod_lifeCycle) {
      body.attributes["CS_PIN_TEST_CFG"] = this.rootScope.accountSAuthConfig?.hasbroTestConfig || "";
      body.attributes["CS_PIN_UDP_TEST_CFG"] = this.rootScope.accountSAuthConfig?.udpTestConfig || "";
    }
     /* istanbul ignore next */
    this.logger.infoLogs("VAL Attributes to be sent to Genesys: " + JSON.stringify(body), this.fileName);
     /* istanbul ignore next */
    this.genesysCloudService.updateParticipantAttributes(this.rootScope.activeCustTab.conversationId, this.rootScope.activeCustTab.customerParticipantId, body).subscribe({
        next: (res) => {
          
          if (res) {
            this.logger.infoLogs("VAL Attributes sent to Genesys successfully" + JSON.stringify(res), this.fileName);
            this.rootScope.activeCustTab.VALData.valProcessActive = true;
            this.rootScope.activeCustTab.VALData.displayStep3Content = false;
            this.rootScope.activeCustTab.VALData.displayStep3ContentAfterResponse = false;
            this.rootScope.activeCustTab.VALData.step3Complete = false;
            this.rootScope.activeCustTab.VALData.step1Complete = true;
            this.rootScope.activeCustTab.VALData.step3Active = false;
            // this.rootScope.activeCustTab.pinEntryApp.step1Active = false;
            // this.rootScope.activeCustTab.pinEntryApp.step1Complete = true;
            // this.rootScope.activeCustTab.pinEntryApp.step2Active = true;
            this.genesysCloudService.updateTelephonyEventData(this.rootScope.genesysCallObj, Constants.AuthCode.VAL, "step1Completed successfully");
            this.genesysCloudService.updateTelephonyEventData(this.rootScope.genesysCallObj, Constants.logEvent.SUCCESS, res?.["attributes"]);

          }
        },
        error: (err) => {
          this.logger.errorLogs("VAL Attributes sent to Genesys failed" + JSON.stringify(err), this.fileName);
        },
      });
  }

  moveBackToStep1() {
    this.rootScope.activeCustTab.VALData.displayStep2Content = false;
    this.rootScope.activeCustTab.VALData.displayStep1Content = true;
    this.rootScope.activeCustTab.VALData.step1Active = true;
    this.rootScope.activeCustTab.VALData.step1Complete = false;
    this.rootScope.activeCustTab.VALData.step2Active = false
    this.selectedLanguage = this.rootScope.activeCustTab.selectedVALLang;
     /*istanbul ignore next */
    this.logger.infoLogs("Step 1 Content Actived for customerSessionId: " + this.rootScope.activeCustTab.customerSessionId, this.fileName);
  }

}
;